export const ADDRESS_BOOK_CONTACT_TYPE_FILTER = {
  JOINED_ONLY: 'JOINED_ONLY',
  CONTACTS_ONLY: 'CONTACTS_ONLY',
};
